namespace $ { $mol_style_attach( "mol/format/format.view.css",
 "[mol_format] {\n\tfont-family: monospace;\n}\n"
) }